import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import DistributionNavigation from '../DistributionNavigation'
import DistributeEmptyState from '../../../UniformComponents/DistributeEmptyState'
import Button from '../../../UniformComponents/Button'
import DataTable from '../../DataTable'
import Panel from '../../../UniformComponents/Panel'
import CampaignLinksModal from '../CampaignLinks/CampaignLinksModal'
import DeleteModal from '../Modal/DeleteModal'
import InterceptLogicModal from './InterceptLogicModal'

import '../distribute.scss'

@observer
class WebsiteIntercept extends Component {
    constructor(props) {
        super(props)

        const { distributeStore } = props

        if (distributeStore.isRapidSurvey()) {
            distributeStore.goToCampaignLinks()
        }

        distributeStore.campaignType = 'intercept'
        distributeStore.getCampaigns('intercept')
    }

    getColumns = () => {
        const { distributeStore, store } = this.props
        const { survey } = store

        return [
            {
                key: 'campaigntitle',
                name: 'Title',
                dataTransform: (value, row) => (
                    [
                        <span className="campaign-links-row-title">{value}</span>,
                        <pre className="campaign-links-link-input" key={`fc_${value}`}>{survey.getInterceptSrc(row.uuid, row.token)}</pre>,
                    ]
                ),
            },
            {
                key: 'campaignId',
                name: '',
                dataTransform: (_, row) => (
                    <div className="campaign-links-table-actions pad-top">
                        <i
                            className="fal fa-copy"
                            title={i18n.t('copy')}
                            onClick={() => store.copyText(survey.getInterceptSrc(row.uuid, row.token), 'Campaign Link')}
                        />
                        {store.isExploriAdmin() && (
                            <i 
                                className="fal fa-cog" 
                                title={i18n.t('options')}
                                onClick={() => { distributeStore.openInterceptRulesModal(row.uuid) }} 
                            />
                        )}
                        <i
                            className="fal fa-edit"
                            title={i18n.t('edit')}
                            onClick={(e) => distributeStore.editCampaign(e, row)}
                        />
                        <i
                            className="fal fa-circle-xmark"
                            title={i18n.t('delete')}
                            onClick={() => distributeStore.showDeleteModal(row.campaignId)}
                        />
                    </div>
                ),
                cellClass: 'center w50 pointer overflow',
            },
        ]
    }

    render() {
        const { store, distributeStore } = this.props
        const { filteredList, filterText } = distributeStore
        const { survey } = store
        const { showBranchBanner } = survey

        return (
            <div className={`${showBranchBanner ? 'branching' : ''} email-landing-content ${process.env.USE_NEW_HEADER_UI ? 'survey-view-wrapper' : ''}`}>
                <DistributionNavigation store={distributeStore} survey={store.survey} />

                <div className="email-landing-right-container">
                    <Panel style={{ padding: 20, overflow: 'visible' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <h2>{i18n.t('distributionWebsiteIntercept.title')}</h2>

                            <Button
                                cssClass="regular tertiary"
                                onClick={distributeStore.showCampaignModal}
                                icon="fal fa-globe"
                                label={i18n.t('distributionWebsiteIntercept.create')}
                            />
                        </div>
                    </Panel>

                    {!filteredList.length && !filterText.length
                        ? (
                            <DistributeEmptyState
                                title={i18n.t('distributionWebsiteIntercept.emptyStateText')}
                                subtext={i18n.t('distributionWebsiteIntercept.emptyStateSubText')}
                                ctaText={i18n.t('distributionWebsiteIntercept.create')}
                                icon="fal fa-globe"
                                ctaIcon="fal fa-globe"
                                onClick={distributeStore.showCampaignModal}
                            />
                        )
                        : (
                            <Panel style={{ padding: 0 }}>
                                <DataTable
                                    store={distributeStore}
                                    dataSet={filteredList}
                                    inMemory
                                    columns={this.getColumns()}
                                />
                            </Panel>
                        )}
                </div>

                <CampaignLinksModal distributeStore={distributeStore} />

                <InterceptLogicModal
                    store={store}
                    distributeStore={distributeStore}
                />

                <DeleteModal distributeStore={distributeStore} />
            </div>
        )
    }
}

export default WebsiteIntercept
